import { TablePagination as MuiTablePagination, Pagination } from "@mui/material";
import { TablePaginationActionsProps } from "@mui/material/TablePagination/TablePaginationActions";
import {
  gridPageCountSelector,
  gridPageSelector,
  gridPageSizeSelector,
  gridPaginationRowCountSelector,
  useGridApiContext,
  useGridSelector
} from "@mui/x-data-grid-pro";
import { Theme } from "klayowebshared";
import { useLocale } from "../providers/LocaleProvider";

interface TablePaginationProps {
  rowsPerPageOptions: number[];
}

const TablePagination = (props: TablePaginationProps) => {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const rowsPerPage = useGridSelector(apiRef, gridPageSizeSelector);
  const count = useGridSelector(apiRef, gridPaginationRowCountSelector);
  const { translate } = useLocale();

  const paginationProps = props?.rowsPerPageOptions;
  return (
    <MuiTablePagination
      component='div'
      page={page}
      rowsPerPage={rowsPerPage}
      {...(paginationProps && { rowsPerPageOptions: paginationProps })}
      onPageChange={(event, value) => {
        apiRef.current.setPage(value);
      }}
      onRowsPerPageChange={async (e) => {
        const newSize = Number(e.target.value);
        await apiRef.current.setPage(0);
        await apiRef.current.setPageSize(newSize);
      }}
      count={count}
      ActionsComponent={PaginationActions}
      labelRowsPerPage={translate("pagination.rowsPerPage")}
      labelDisplayedRows={({ from, to, count }) =>
        translate("pagination.displayedRows", { from, to, count: count !== -1 ? count : `>${to}` })
      }
      sx={{
        "&.MuiTablePagination-root": {
          borderBottom: "unset"
        }
      }}
    />
  );
};

const PaginationActions = ({ className }: TablePaginationActionsProps) => {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <div className={className}>
      <Pagination
        className={className}
        count={pageCount}
        page={page + 1}
        onChange={(_, value) => {
          apiRef.current.setPage(value - 1);
        }}
        sx={{
          "& .MuiPaginationItem-root.Mui-selected": {
            color: Theme.getStyleVar("--grey-gr-050"),
            backgroundColor: Theme.getStyleVar("--neon-blue-nb-500")
          }
        }}
      />
    </div>
  );
};

export default TablePagination;
